export const REQUEST_ORG_PACKAGE_PLANS =
  'orgPackagePlans/REQUEST_ORG_PACKAGE_PLANS';
export const SET_ORG_PACKAGE_PLANS = 'orgPackagePlans/SET_ORG_PACKAGE_PLANS';
